import React from "react";
import PropTypes from "prop-types";

const Button = ({name, handleSubmit, disabled}) => {
  return (
    <div className="w-100 my-1">
      <button
        type="submit"
     
        className=""
        onClick={(e) => {
          e.preventDefault()
          handleSubmit(e);
        }}
        disabled={disabled}
      >
        <span className="text-white-btn">{name}</span>

       
      </button>
    </div>
  );
};

Button.prototype = {
  name: PropTypes.string,
  handleSubmit: PropTypes.func,
  disabled: PropTypes.bool
};

export default Button;
